/* Sample Kit PDP — FAQ accordion. One panel open at a time. */
(function () {
  'use strict';

  // This file is emitted by every instance of its section, so it can be
  // executed several times on one page. Bind once; later copies bail out.
  if (window.__skpFaqInit) return;
  window.__skpFaqInit = true;

  var seen = new WeakSet();

  function setup(root) {
    if (seen.has(root)) return;
    seen.add(root);
    if (root.hasAttribute('data-skp-bound')) return;
    root.setAttribute('data-skp-bound', '');

    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-skp-faq-toggle]'));

    // Resolve the panel by id, falling back to the element right after the
    // toggle. Ids are generated from section.id, and an unexpected or
    // duplicated one would silently break every accordion on the page.
    function panelFor(toggle) {
      var id = toggle.getAttribute('aria-controls');
      var byId = id ? document.getElementById(id) : null;
      return byId || toggle.nextElementSibling;
    }

    function close(t) {
      var panel = panelFor(t);
      if (!panel) return;
      // Pin the measured height first so the collapse has something to animate
      // from — `height: auto` is not a transitionable value.
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.height = '0px'; });
      t.setAttribute('aria-expanded', 'false');
    }

    function open(t) {
      var panel = panelFor(t);
      if (!panel) return;
      panel.style.height = panel.scrollHeight + 'px';
      t.setAttribute('aria-expanded', 'true');
      panel.addEventListener('transitionend', function h(e) {
        if (e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', h);
        if (t.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
      });
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var isOpen = t.getAttribute('aria-expanded') === 'true';
        toggles.forEach(function (o) {
          if (o !== t && o.getAttribute('aria-expanded') === 'true') close(o);
        });
        if (isOpen) close(t); else open(t);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-skp-faq]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
